// extracted by mini-css-extract-plugin
export default {"box":"styles_box__njATq","logo":"styles_logo__6Gec9","contact":"styles_contact__-kuQ-"};